import styled from "styled-components";

export const Container = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  width: 100%;
  & > div:first-child {
    box-shadow: none;
  }
`;

export const ListContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white["900"]};
  display: flex;
  gap: ${({ theme }) => theme.space["space-3"]};
  overflow: auto;
  padding: 0 8px 12px;
  scroll-snap-type: x mandatory;
  scroll-padding-left: ${({ theme }) => theme.space["space-2"]};
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Element = styled.div`
  scroll-snap-align: start;
`;

const Box = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.colorTokens.border.subtle}`};
`;

export const NoUpcomingRacesWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
